import { pluginRegistry } from './PluginRegistry';

// 🔌 Import de TOUS les plugins disponibles
import DocumentViewerPluginModular from '../plugins/DocumentViewerPluginModular';
//import EcommerceShopPluginModular from '../plugins/EcommerceShopPluginModular';
import EcommerceShopPlugin from '../plugins/EcommerceShop';
import AudioPlayerPluginModular from '../plugins/AudioPlayerPluginModular';
import CalendarPluginModular from '../plugins/CalendarPluginModular';
import GeolocationPluginModular from '../plugins/GeolocationPluginModular';
import ImageGalleryPluginModular from '../plugins/ImageGalleryPluginModular';
import SurveyPluginModular from '../plugins/SurveyPluginModular';
import WeatherPluginModular from '../plugins/WeatherPluginModular';
import RentalPluginModular from '../plugins/RentalPlugin';
import SwiklyDepositPluginModular from '../plugins/SwiklyDepositPluginModular';
import PaymentButtonsModular from '../plugins/PaymentButtonsModular';
import EventBookingPlugin from '../plugins/EventBooking'; // ✅ Ajouter
import LiveClassPluginModular from '../plugins/LiveClassPluginModular'; // Import

let pluginsInitialized = false;

export function initializeModularPlugins() {
  if (pluginsInitialized) {
    return;
  }

  console.log('🔌 Démarrage de l\'enregistrement centralisé des plugins...');

  // 🚀 Enregistrement de TOUS les plugins
  pluginRegistry.register(DocumentViewerPluginModular);
  pluginRegistry.register(EcommerceShopPlugin);
  pluginRegistry.register(AudioPlayerPluginModular);
  pluginRegistry.register(CalendarPluginModular);
  pluginRegistry.register(GeolocationPluginModular);
  pluginRegistry.register(ImageGalleryPluginModular);
  pluginRegistry.register(SurveyPluginModular);
  pluginRegistry.register(WeatherPluginModular);
  pluginRegistry.register(RentalPluginModular);
  pluginRegistry.register(SwiklyDepositPluginModular);
  pluginRegistry.register(PaymentButtonsModular); // 💳 Bouton de paiement (Stripe/PayPal)
  pluginRegistry.register(EventBookingPlugin); // ✅ Enregistrer
  pluginRegistry.register(LiveClassPluginModular); // ✅ AJOUT

  // ✅ AJOUTEZ CE LOG POUR VOIR LE CONTENU DU REGISTRE APRÈS L'INITIALISATION
  console.log('%cREGISTRE APRÈS INIT:', 'color: green; font-weight: bold;', pluginRegistry.getAll());

  // ✅ Marquer l'initialisation comme terminée
  pluginsInitialized = true;
}

const plugins = [
  AudioPlayerPluginModular,
  CalendarPluginModular,
  GeolocationPluginModular, // ✅ CORRIGÉ
  ImageGalleryPluginModular,
  SurveyPluginModular,
  WeatherPluginModular, // Manquait
  RentalPluginModular, // Ajouté
  SwiklyDepositPluginModular, // Ajouté
  PaymentButtonsModular, // Ajouté
  EventBookingPlugin, // ✅ Ajouté
  LiveClassPluginModular, // ✅ AJOUT
];
